import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { recruitmentAdminApi } from '../../../services/api'
import Button from '../../../components/ui/Button'
import LoadingSpinner from '../../../components/ui/LoadingSpinner'
import Card from '../../../components/ui/Card'
import AdminFormField, { adminInputClass } from '../../../components/admin/AdminFormField'

export default function AdminRecruitmentSettings() {
  const { t } = useTranslation()
  const [form, setForm] = useState({
    hr_email: '',
    notification_email: '',
    careers_page_title_en: '',
    careers_page_title_ar: '',
    careers_page_intro_en: '',
    careers_page_intro_ar: '',
  })
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [saved, setSaved] = useState(false)

  useEffect(() => {
    recruitmentAdminApi.settings
      .get()
      .then(({ data }) => {
        const settings = data.data || {}
        setForm((prev) => ({
          ...prev,
          hr_email: settings.hr_email?.value_en || '',
          notification_email: settings.notification_email?.value_en || '',
          careers_page_title_en: settings.careers_page_title_en?.value_en || '',
          careers_page_title_ar: settings.careers_page_title_ar?.value_ar || settings.careers_page_title_ar?.value_en || '',
          careers_page_intro_en: settings.careers_page_intro_en?.value_en || '',
          careers_page_intro_ar: settings.careers_page_intro_ar?.value_ar || settings.careers_page_intro_ar?.value_en || '',
        }))
      })
      .finally(() => setLoading(false))
  }, [])

  const handleSave = async (e) => {
    e.preventDefault()
    setSaving(true)
    setSaved(false)
    try {
      await recruitmentAdminApi.settings.update(form)
      setSaved(true)
    } finally {
      setSaving(false)
    }
  }

  if (loading) return <LoadingSpinner className="py-20" />

  return (
    <Card>
      <form onSubmit={handleSave} className="grid gap-4 sm:grid-cols-2">
        <AdminFormField label={t('admin.recruitment.hrEmail')} htmlFor="recruitment-hr-email" className="sm:col-span-2">
          <input
            id="recruitment-hr-email"
            type="email"
            value={form.hr_email}
            onChange={(e) => setForm({ ...form, hr_email: e.target.value })}
            className={adminInputClass}
          />
        </AdminFormField>
        <AdminFormField label={t('admin.recruitment.notificationEmail')} htmlFor="recruitment-notification-email" className="sm:col-span-2">
          <input
            id="recruitment-notification-email"
            type="email"
            value={form.notification_email}
            onChange={(e) => setForm({ ...form, notification_email: e.target.value })}
            className={adminInputClass}
          />
        </AdminFormField>
        <AdminFormField label={t('admin.recruitment.fields.careersPageTitleEn')} htmlFor="recruitment-careers-title-en">
          <input
            id="recruitment-careers-title-en"
            value={form.careers_page_title_en}
            onChange={(e) => setForm({ ...form, careers_page_title_en: e.target.value })}
            className={adminInputClass}
          />
        </AdminFormField>
        <AdminFormField label={t('admin.recruitment.fields.careersPageTitleAr')} htmlFor="recruitment-careers-title-ar">
          <input
            id="recruitment-careers-title-ar"
            value={form.careers_page_title_ar}
            onChange={(e) => setForm({ ...form, careers_page_title_ar: e.target.value })}
            dir="rtl"
            lang="ar"
            className={`${adminInputClass} font-ar`}
          />
        </AdminFormField>
        <AdminFormField label={t('admin.recruitment.fields.careersPageIntroEn')} htmlFor="recruitment-careers-intro-en">
          <textarea
            id="recruitment-careers-intro-en"
            rows={3}
            value={form.careers_page_intro_en}
            onChange={(e) => setForm({ ...form, careers_page_intro_en: e.target.value })}
            className={adminInputClass}
          />
        </AdminFormField>
        <AdminFormField label={t('admin.recruitment.fields.careersPageIntroAr')} htmlFor="recruitment-careers-intro-ar">
          <textarea
            id="recruitment-careers-intro-ar"
            rows={3}
            value={form.careers_page_intro_ar}
            onChange={(e) => setForm({ ...form, careers_page_intro_ar: e.target.value })}
            dir="rtl"
            lang="ar"
            className={`${adminInputClass} font-ar`}
          />
        </AdminFormField>
        <div className="sm:col-span-2">
          <Button type="submit" variant="primary" disabled={saving}>{t('buttons.save')}</Button>
          {saved && <span className="ms-4 text-sm text-green-600">{t('admin.settingsAdmin.saved')}</span>}
        </div>
      </form>
    </Card>
  )
}
